<template>
  <div style="width: 100%;">
    <div style="width: 700px;margin: 0 auto;border: 1px solid #ddd;">
      <div style="font-size: 20px;text-align: center;margin-top: 20px;">
        自定义订单_单价管理
      </div>
      <div>
        <el-divider></el-divider>
      </div>
      <table width="100%" border="0" cellspacing="10" cellpadding="15" v-loading="loading_Un">
        <tr>
          <td width="40%"><div style="text-align: right;">擀价（元/斤）：</div></td>
          <td><div style="text-align: left;"><el-input v-model="update.ganjia" placeholder="请输入内容" size="small" style="width: 70%;"></el-input></div></td>
        </tr>
        <tr>
          <td><div style="text-align: right;">面粉（元/斤）：</div></td>
          <td><div style="text-align: left;"><el-input v-model="update.mianfen" placeholder="请输入内容" size="small" style="width: 70%;"></el-input></div></td>
        </tr>
        <tr>
          <td><div style="text-align: right;">鸡蛋（元/个）：</div></td>
          <td><div style="text-align: left;"><el-input v-model="update.jidan" placeholder="请输入内容" size="small" style="width: 70%;"></el-input></div></td>
        </tr>
        <tr>
          <td><div style="text-align: right;">饺皮（元/斤）：</div></td>
          <td><div style="text-align: left;"><el-input v-model="update.jiaopi" placeholder="请输入内容" size="small" style="width: 70%;"></el-input></div></td>
        </tr>
        <tr>
          <td><div style="text-align: right;">饺子皮（元/斤）：</div></td>
          <td><div style="text-align: left;"><el-input v-model="update.jiaozipi" placeholder="请输入内容" size="small" style="width: 70%;"></el-input></div></td>
        </tr>
        <tr>
          <td><div style="text-align: right;">豆面（元/包）：</div></td>
          <td><div style="text-align: left;"><el-input v-model="update.doumian" placeholder="请输入内容" size="small" style="width: 70%;"></el-input></div></td>
        </tr>
      </table>
      <div>
        <el-divider></el-divider>
      </div>
      <div style="text-align: center;margin-bottom: 20px;">
        <el-button type="primary" round @click="updateUnivalence">保存</el-button>
        <el-button type="primary" round @click="getData">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
export default {
  data () {
    return {
      //加载
      loading_Un:false,
      //信息
      update:{
        admin_id:'',
        jiaopi:0,
        jiaozipi:0,
        jidan:0,
        mianfen:0,
        doumian:0,
        ganjia:0,
      },
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
      },
    }
  },
  //页面开启时执行
  mounted(){
    this.chark();
    this.getData();
  },
  methods: {
    //进行判定
    chark(){
      this.$emit("parentHandle", 2)
    },
    updateUnivalence(){
      if(this.update.mianfen==''||this.update.ganjia==''||this.update.jiaozipi==''||this.update.jiaopi==''||this.update.jidan==''||this.update.doumian==''){
        this.$message({
          message: '请将数据填写完整',
          type: 'warning'
        });
        return false;
      }
      this.update.admin_id=this.$store.state.a_id;
      commonAPI('updateUnivalence',this.update).then(res => {
        let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
          })
    },
    getData(){
      this.loading_Un=true;
      commonAPI('queryUnivalence',this.AdminInfor).then(res => {
        this.update = res.data.data.rows[0];
        this.loading_Un=false;
        //console.log(res.data.rows);
      })
    },
    //获取信息方法
    judgeLogin(){
      this.AdminInfor.id=this.$store.state.a_id;
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/admin/views/goods/Univalence.vue